import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { NotApplicablePipe } from 'src/app/shared/pipes/not-applicable.pipe';

export interface Specification {
  details: string;
  name: string;
}

const MAX_SPECIFICATIONS_TO_SHOW = 4;

@Component({
  standalone: true,
  selector: 'base-specifications',
  templateUrl: './specifications.component.html',
  styleUrls: ['./specifications.component.scss'],
  imports: [CommonModule, NotApplicablePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecificationsComponent {

  MAX_SPECIFICATIONS_TO_SHOW = MAX_SPECIFICATIONS_TO_SHOW;

  readonly specifications = input<Specification[]>([]);

  // Signal for expanded state
  private readonly _isExpanded = signal(false);

  // Computed signal for filtered specifications
  readonly filteredSpecifications = computed(() => {
    const specs = this.specifications();
    return specs.filter(specification => specification.name && specification?.name !== '');
  });

  // Computed signal to check if there are more specifications to show
  readonly hasMoreSpecifications = computed(() => {
    return this.filteredSpecifications().length > MAX_SPECIFICATIONS_TO_SHOW;
  });

  // Computed signal for specifications to display based on expanded state
  readonly specificationsToShow = computed(() => {
    const filtered = this.filteredSpecifications();
    const maxToShow = this._isExpanded() ? filtered.length : MAX_SPECIFICATIONS_TO_SHOW;
    return filtered.slice(0, maxToShow);
  });

  // Computed signal for expanded state (public accessor)
  readonly isExpanded = computed(() => this._isExpanded());

  // Method to toggle the expanded state
  toggleViewMoreComments(): void {
    this._isExpanded.set(!this._isExpanded());
  }
}

